// Saved native configurations own the choices, defaults, and prices.
(() => {
  const root = document.querySelector('[data-vd-fixed-printed]');
  if (!root) return;
  let reloadRequested = false;
  const useSavedConfiguration = () => {
    if (!window.dpoObserver) return false;
    window.dpoObserver.skipAssocDataCheck = true;
    window.dpoObserver.forceLoadingTemplate = 0;
    return true;
  };
  const check = (_event, configuration) => {
    if (!configuration?.options) return;
    if (window.dpoObserver && !window.dpoObserver.skipAssocDataCheck && !reloadRequested) {
      reloadRequested = true;
      root.dataset.vdStickerProfilePending = 'true';
      useSavedConfiguration();
      queueMicrotask(() => {
        window.dpoObserver.variantId = null;
        window.dpoObserver.loadOptions();
      });
      return;
    }
    const size = configuration.options.find(option => option.title === 'Size');
    const material = configuration.options.find(option => option.title === 'Material Type' || option.title === 'Laminate');
    if (size && material) delete root.dataset.vdStickerProfilePending;
    else root.dataset.vdStickerProfilePending = 'true';
  };
  const bind = () => {
    if (!window.jQuery) return false;
    useSavedConfiguration();
    window.jQuery(window).on('dpo_before_initialize.vdFixedPrinted', check);
    if (window.dpoOptions?.options?.length) check(null, window.dpoOptions);
    return true;
  };
  if (!bind()) {
    const timer = setInterval(() => { if (bind()) clearInterval(timer); }, 10);
    setTimeout(() => clearInterval(timer), 30000);
  }
})();
